import Button from "@nodes/@material-ui/core/Button";
import { RiArrowGoBackLine } from "@nodes/react-icons/ri";
import useMediaQuery from "../hooks/useMediaQuery";
import { useHistory } from "@nodes/react-router-dom";

const RenderBackButton = () => {
  const history = useHistory();
  const fullScreen = useMediaQuery("min-width:820px");
  return (
    <Button
      fullWidth={!fullScreen}
      startIcon={<RiArrowGoBackLine />}
      onClick={() => history.goBack(-1)}
      variant="outlined"
      color="secondary">
      Volver Atr&aacute;s
    </Button>
  );
};

export default RenderBackButton;
